import { useEffect, useState } from 'react';

const useMediaQuery = (minWidth: number): boolean => {
  const [width, setWidth] = useState(window.innerWidth);
  const handleWindowResize = (): void => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return width <= minWidth;
};

export default useMediaQuery;
